/**
 * Strongly typed identifier for a service.
 */
var ServiceIdentifier = /** @class */ (function () {
    /**
     * Creates a service identifier.
     * @param name Name used for debugging, not required to be unique.
     * @param symbol_ Optional symbol used for container binding.
     */
    function ServiceIdentifier(name, symbol) {
        if (symbol === void 0) { symbol = Symbol(name); }
        this.symbol = symbol;
        if (ServiceIdentifier.typeNames.has(name)) {
            console.error("Warning: Service type ".concat(name, " has already been registered!"));
        }
        else {
            ServiceIdentifier.typeNames.add(name);
        }
    }
    /**
     * Changes the type of the service identifier.
     */
    ServiceIdentifier.prototype.asType = function () {
        return this;
    };
    /**
     * Creates a service identifier from the given type and key.
     * @param key Unique key for the symbol which is created.
     */
    ServiceIdentifier.for = function (key) {
        return new ServiceIdentifier(key, Symbol.for(key));
    };
    ServiceIdentifier.prototype.toString = function () {
        return this.symbol.toString();
    };
    ServiceIdentifier.typeNames = new Set();
    return ServiceIdentifier;
}());
export { ServiceIdentifier };
